import { useEffect } from 'react';
import { useProjectStore } from '../store/projectStore';
import { getCurrentTenantId } from '../store/tenantStorage';
import { useUserTenants } from './api/useUserTenants';

export function validateProjectTenantAlignment({
  authTenantId,
}: {
  authTenantId?: string | null;
} = {}): void {
  const currentTenantId = getCurrentTenantId(authTenantId);

  if (!currentTenantId) {
    return;
  }

  const { selectedCompany, selectedTarget, clearProject } =
    useProjectStore.getState();

  const companyTenantId = selectedCompany?.tenantId;
  const applicationTenantId = selectedTarget?.tenantId;

  if (companyTenantId && companyTenantId !== currentTenantId) {
    clearProject();

    return;
  }

  if (applicationTenantId && applicationTenantId !== currentTenantId) {
    clearProject();
  }
}

export function useValidateProjectTenant(): void {
  const { currentTenantId: authTenantId, isFetched: isTenantsFetched } =
    useUserTenants();

  useEffect(() => {
    if (!isTenantsFetched) {
      return;
    }

    const runValidation = () =>
      validateProjectTenantAlignment({ authTenantId });

    const unsubscribe =
      useProjectStore.persist.onFinishHydration(runValidation);

    runValidation();

    return unsubscribe;
  }, [authTenantId, isTenantsFetched]);
}
